($ => {
  const previewZoom = {
    zoomRatio: 3,
    
    previewContainer: false,
    currentView: false,
    zoom: {wrapper: false, img: false},
    size: {w: false, h: false},    
    init() {
      this.previewContainer = $('.cpb-preview-container')      
      this.setObserver(this.previewContainer[0])
      this.activateZoom()
    },
    setObserver(container) {
      const observer = new MutationObserver(function() {
        this.currentView = CPB.getStore().getState().App.settings.currentView
      }.bind(this))
      observer.observe(container, {attributes: true, childList: true, subtree: true})
      return observer
    },
    activateZoom() {
      const that = this
      this.zoom.wrapper = $('<div class="cpb-custom-preview-zoom">')
      this.zoom.img = $('<img class="cpb-custom-preview-zoom__image">').css('transform', 'scale(' + this.zoomRatio + ')')
      this.zoom.wrapper.append(this.zoom.img)
      
      $(document).on('mouseenter', '.cpb-render-konva', function(e) {
        const convaContainer = $(this)
        that.size.w = convaContainer[0].clientWidth
        that.size.h = convaContainer[0].clientHeight
        that.zoom.img.attr('src', that.getViewImageURL(that.currentView, that.zoomRatio))
        convaContainer.append(that.zoom.wrapper)
      })
      $(document).on('mouseleave', '.cpb-render-konva', function(e) {
        that.zoom.wrapper.detach()
      })
      $(document).on('mousemove', '.cpb-render-konva', function(e) {
        const posX = 100 - (that.size.w - e.offsetX) / that.size.w * 100
        const posY = 100 - (that.size.h - e.offsetY) / that.size.h * 100
        that.zoom.img.css('transform-origin', posX + '%' + ' ' + posY + '%')
      })
    },
    getViewImageURL(view, ratio) {
      if (typeof window.cpbImageStorage === 'undefined') return
      const getDataURL = cpbImageStorage.views[view].getSnapshot(ratio)
      return getDataURL
    }
  }

  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
    previewZoom.init()
    previewContainerWidth()
  })
})(jQuery)